__turbopack_context__.v({
  "skeletonCard": "SkeletonCards-module-scss-module__87GwMq__skeletonCard",
  "skeletonCards": "SkeletonCards-module-scss-module__87GwMq__skeletonCards",
  "skeletonHeader": "SkeletonCards-module-scss-module__87GwMq__skeletonHeader",
});
